import { render, staticRenderFns } from "./WhatsappMessageLog.vue?vue&type=template&id=6b5e2f6c&scoped=true"
import script from "./WhatsappMessageLog.vue?vue&type=script&lang=js"
export * from "./WhatsappMessageLog.vue?vue&type=script&lang=js"
import style0 from "./WhatsappMessageLog.vue?vue&type=style&index=0&id=6b5e2f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5e2f6c",
  null
  
)

export default component.exports